module.exports = __webpack_public_path__ + "img/yu.6ec0baca.png";